import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { ZONES } from "@/data/content";
import { Reveal, SectionLabel } from "./Reveal";

const MotionLink = motion.create(Link);

const ZoneCard = ({ z, i }) => (
  <MotionLink
    to={`/zones/${z.key}`}
    data-testid={`zone-card-${z.key}`}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.1 }}
    transition={{ duration: 0.8, delay: (i % 3) * 0.08, ease: [0.22, 1, 0.36, 1] }}
    className={`block group relative overflow-hidden rounded-[28px] border border-white/10 hover:border-[#14C3F7]/70 transition-colors duration-300 text-left h-[300px] md:h-auto ${z.span}`}
  >
    <img src={z.img} alt={z.title} loading="lazy" className="absolute inset-0 w-full h-full object-cover transition-transform duration-[1.2s] ease-out group-hover:scale-[1.07]" />
    <div className="absolute inset-0 bg-gradient-to-t from-[#07080E] via-[#07080E]/40 to-transparent" />
    <div className="absolute top-5 left-5 font-mono text-[11px] uppercase tracking-[0.25em] text-[#FFEF00] bg-black/50 backdrop-blur-md rounded-full px-3 py-1.5">{z.tag}</div>
    <div className="absolute top-5 right-5 w-11 h-11 rounded-full bg-[#FFEF00] text-black flex items-center justify-center scale-0 group-hover:scale-100 transition-transform duration-300">
      <ArrowUpRight size={20} />
    </div>
    <div className="absolute bottom-0 inset-x-0 p-6 md:p-7">
      <h3 className="font-display font-extrabold text-2xl md:text-3xl text-white">{z.title}</h3>
      <p className="mt-2 text-sm md:text-base text-slate-300 max-w-md">{z.copy}</p>
    </div>
  </MotionLink>
);

export const Zones = () => (
  <section id="zones" data-testid="zones-section" className="relative py-24 md:py-32">
    <div className="max-w-[1400px] mx-auto px-5 md:px-10">
      <div className="grid md:grid-cols-12 gap-6 mb-14 items-end">
        <Reveal className="md:col-span-7">
          <SectionLabel>The playground</SectionLabel>
          <h2 className="font-display font-black uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">15 zones.<br /><span className="text-[#FFEF00]">Zero chill.</span></h2>
        </Reveal>
        <Reveal className="md:col-span-5" delay={0.1}>
          <p className="text-slate-300 text-base md:text-lg leading-relaxed">Bowling, arcade, VR, bumper cars, laser tag, horror house, soft play, trampolines, go-karts, mirror maze, sports simulators, dining and party zones — all under one neon roof. Tap a zone to explore.</p>
        </Reveal>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-12 md:auto-rows-[260px] md:grid-flow-dense gap-5">
        {ZONES.map((z, i) => <ZoneCard key={z.key} z={z} i={i} />)}
      </div>
    </div>
  </section>
);
